import React from 'react';
import Header from './Header';
import * as LayoutUI from './LayoutUI';
import NewVersionChecker from './NewVersionChecker';
import PollAnalysis from './PollAnalysis';
import { IS_SCREENSHOT_MODE } from '../config/constants';
import WsNotification from './WsNotification';
import LayoutContainer from './LayoutContainer';
import { TooltipWheelProvider } from '../components/Chart/CustomTooltip/CustomTooltipWheelContext';
import ScreenshotModeLayout from './ScreenshotModeLayout';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  // in screenshot mode we will not render sidebar and header
  // this is used for the screenshot service, not for external embeds
  if (IS_SCREENSHOT_MODE) {
    return <ScreenshotModeLayout />;
  }

  return (
    <LayoutContainer>
      <Header />
      <LayoutUI.ContentWrapper id={'main-content-wrapper'}>
        <PollAnalysis />
        <TooltipWheelProvider>
          <Outlet />
        </TooltipWheelProvider>
      </LayoutUI.ContentWrapper>
      <NewVersionChecker />
      <WsNotification />
    </LayoutContainer>
  );
};

export default Layout;
